// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"0547bb12","418":"6e2ec461","429":"37ef4d1f"}[chunkId] + ".chunk.css";
};